import { useEffect, useState } from "react";
import WorkOrder from "../../../models/workOrder";
import WorkOrderFileShareAction from "./WorkOrderFileShareAction";
import ModalWindow from "../../common/ModalWindow";
import workOrderStatusHelper from "../../../models/workOrderStatusHelper";
import WorkOrderStatus from "../../../models/workOrderStatus";
import workOrderService from "../../../services/workOrderService";
import File from "../../../models/file";
import workOrderHelper from "../../../models/workOrderHelper";

const WorkOrderFileShareWindow: React.FC<{
  idSubscription: number;
  workOrder: WorkOrder;
  selectedFiles: File[];
  setShowShareWindow: any;
  onOk: any;
}> = ({
  idSubscription,
  workOrder,
  selectedFiles,
  setShowShareWindow,
  onOk,
}) => {
  const [allWorkOrders, setAllWorkOrders] = useState<WorkOrder[]>([]);

  const [workOrders, setWorkOrders] = useState<WorkOrder[]>([]);

  const [selectedWorkOrders, setSelectedWorkOrders] = useState<WorkOrder[]>([]);

  const [searchText, setSearchText] = useState<string>("");

  const [selectedAction, setSelectedAction] =
    useState<WorkOrderFileShareAction>(WorkOrderFileShareAction.Share);

  useEffect(() => {
    // const workOrders = [...allWorkOrders];
    // setWorkOrders(workOrders);

    const allWorkOrders: WorkOrder[] = [];

    if (workOrder.parentWorkOrderNumber) {
      const parentWorkOrder = new WorkOrder();
      parentWorkOrder.workOrderNumber = workOrder.parentWorkOrderNumber;
      parentWorkOrder.entityName = workOrder.parentEntityName;

      allWorkOrders.push(parentWorkOrder);
    }

    if (workOrder.childrenWorkOrders.length > 0) {
      for (const wo of workOrder.childrenWorkOrders) {
        allWorkOrders.push(wo);
      }
    }

    setAllWorkOrders(allWorkOrders);
  }, [workOrder]);

  useEffect(() => {
    const searchToken = searchText.toLowerCase();

    let filtered = allWorkOrders.filter((wo) =>
      workOrderHelper
        .getWorOrderDisplayName(wo)
        .toLowerCase()
        .includes(searchToken.toLocaleLowerCase()),
    );

    setWorkOrders(filtered);
  }, [allWorkOrders, searchText]);

  const onSearchTextChange = (event: any) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
  };

  const onSelectedChanged = (event: any, workOrder: WorkOrder) => {
    const checked = event.target.checked;

    if (checked) {
      const wo = workOrders.find((wo) => wo === workOrder);
      if (wo) {
        const newSelectedWorkOrders = [...selectedWorkOrders];
        newSelectedWorkOrders.push(wo);
        setSelectedWorkOrders(newSelectedWorkOrders);
      }
    } else {
      const remainingWorkOrders = selectedWorkOrders.filter(
        (wo) => wo !== workOrder,
      );
      setSelectedWorkOrders(remainingWorkOrders);
    }
  };

  const onActionChanged = async (event: any) => {
    const newValue = event.target.value;
    setSelectedAction(newValue);
  };

  const onShareOk = async () => {
    const isShareAction = selectedAction === WorkOrderFileShareAction.Share;
    const fileResourceIds = selectedFiles.map((f) => f.resourceId);
    const fromWorkOrderNumber = workOrder.workOrderNumber;
    const toWorkOrderNumbers = selectedWorkOrders.map(
      (wo) => wo.workOrderNumber,
    );

    await workOrderService.shareWorkOrderFiles(
      idSubscription,
      isShareAction,
      fileResourceIds,
      fromWorkOrderNumber,
      toWorkOrderNumbers,
    );

    setShowShareWindow(false);

    if (onOk) {
      onOk();
    }
  };

  const isOkEnabled = selectedWorkOrders.length > 0;

  const isWorkOrderSelected = (workOrder: WorkOrder) => {
    return selectedWorkOrders.find((wo) => wo === workOrder) !== undefined;
  };

  return (
    <ModalWindow
      title="Share Work Order Files"
      okTitle={selectedAction}
      onOk={onShareOk}
      onCancel={() => setShowShareWindow(false)}
      isOkEnabled={isOkEnabled}
    >
      <div>
        <div className="mb-3">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchText}
              onChange={onSearchTextChange}
            />
            <button type="submit" className="btn btn-primary">
              Search
            </button>
          </div>
        </div>

        <div
          style={{ maxHeight: "400px", overflowY: "scroll" }}
          className="mb-3"
        >
          <div className="mb-3">
            {selectedAction === WorkOrderFileShareAction.Share && (
              <b>{selectedAction} with</b>
            )}
            {selectedAction === WorkOrderFileShareAction.Unshare && (
              <b>{selectedAction} from</b>
            )}
          </div>
          <table className="table table-borderless table-hover">
            <tbody>
              {workOrders.map((workOrder: WorkOrder, index) => (
                <tr key={index.toString()}>
                  <td style={{ width: "10px" }}>
                    <input
                      className="form-check-input form-switch-right-text"
                      type="checkbox"
                      checked={isWorkOrderSelected(workOrder)}
                      onChange={(event) => onSelectedChanged(event, workOrder)}
                    />
                  </td>
                  <td>
                    <span>
                      {workOrderHelper.getWorOrderDisplayName(workOrder)}{" "}
                      {workOrder.workOrderStatus !== WorkOrderStatus.None && (
                        <span
                          className={workOrderStatusHelper.getBadgeClass(
                            workOrder.workOrderStatus,
                          )}
                        >
                          {workOrderStatusHelper.getDisplayValue(
                            workOrder.workOrderStatus,
                          )}
                        </span>
                      )}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-3">
          <div className="mb-3">
            <b>Choose Action</b>
          </div>
          <select
            className="form-select"
            aria-label="select"
            id="dateRangeSelect"
            value={selectedAction}
            onChange={onActionChanged}
          >
            <option value={WorkOrderFileShareAction.Share}>Share</option>
            <option value={WorkOrderFileShareAction.Unshare}>Unshare</option>
          </select>
        </div>

        <div>
          {selectedAction === WorkOrderFileShareAction.Share && (
            <span>
              {selectedFiles.length} selected{" "}
              {selectedFiles.length === 1 ? "file" : "files"} will be shared
              with{" "}
              {`${selectedWorkOrders.length} ${
                selectedWorkOrders.length === 1 ? "work order" : "work orders"
              }.`}
            </span>
          )}
          {selectedAction === WorkOrderFileShareAction.Unshare && (
            <span>
              {selectedFiles.length} selected{" "}
              {selectedFiles.length === 1 ? "file" : "files"} will be unshared
              from{" "}
              {`${selectedWorkOrders.length} ${
                selectedWorkOrders.length === 1 ? "work order" : "work orders"
              }.`}
            </span>
          )}
        </div>
      </div>
    </ModalWindow>
  );
};

export default WorkOrderFileShareWindow;
